import * as React from 'react';
import {
    ActionPointInfo,
    Controller, CustomArgs, IActionPointInfo,
    Menu,
    Toolbar,
} from '@tencent/workbench';
import { InsertAudioFeature } from './insert-audio-feature';
import { MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';
import { CLICK_FROM } from '../../constant';

@Controller({
    menuItems: MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class InsertAudioController {
    public constructor(private readonly feature: InsertAudioFeature) {}

    @Menu(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick', { clickFrom: CLICK_FROM.TOOLBAR })
    public onClick(@ActionPointInfo() info: IActionPointInfo, @CustomArgs() args: { clickFrom?: string }) {
        const { name } = info;
        const { clickFrom } = args;
        this.feature.insertAudio(name, clickFrom);
    }
}
